const { validateUrl, validateUUID } = require("../validator/validators");

function verifyIfHasErrorInParams(params) {
  const {  baseUrl } = params;
  let msg = ``, txt = ``;
  if (!validateUrl(baseUrl)) {
    txt = `baseUrl is not valid or not has provided.\n`;
    msg ? msg += txt : msg = txt;
  }
  return msg;
}

function verifyAccessTokenAndBaseUrlParams(params) {
  const { accessToken, baseUrl } = params;
  let msg = ``, txt = ``;
  if (!validateUrl(baseUrl)) {
    txt = `baseUrl is not valid or not has provided.\n`;
    msg ? msg += txt : msg = txt;
  }
  if (!accessToken) {
    txt = `accessToken is not has provided.\n`;
    msg ? msg += txt : msg = txt;
  }
  return msg;
}

module.exports = {
  verifyIfHasErrorInParams,
  verifyAccessTokenAndBaseUrlParams
}
